export const AddToCalendarPlacement = {
    ALERT: 'ALERT',
    EVENT_CARD: 'EVENT_CARD'
};

export const AdobePass = {
    METADATA: {
        TTL_AUTHN: 'TTL_AUTHN',
        TTL_AUTHZ: 'TTL_AUTHZ',
        USERID: 'userID',
        UPSTREAM_USERID: 'upstreamUserID'
    }
};

export const AlertPlacement = {
    PLAYER: 'PLAYER',
    EVENT_CARD: 'EVENT_CARD'
};

export const Api = {
    Page: {
        EVENT_QUERY_KEYS: [
            'airingId',
            'eventId',
            'id'
        ]
    }
};

export const AppEnvs = {
    prod: 'PROD',
    qa: 'QA',
    dev: 'DEV'
};

export const BlackoutTypes = {
    DMA: 'dma',
    DEVICE: 'device'
};

export const BucketLayout = {
    COLLECTION: 'COLLECTION',
    DEFAULT: 'DEFAULT',
    DEFAULT_UNLIMITED: 'DEFAULT_UNLIMITED',
    HERO: 'HERO',
    TAPESTRY_LEFT: 'TAPESTRY_LEFT',
    TAPESTRY_RIGHT: 'TAPESTRY_RIGHT',
    SixteenNineTapestryLeft: 'TAPESTRY_LEFT',
    SixteenNineTapestryRight: 'TAPESTRY_RIGHT',
    SCHEDULE_MODULE: 'SCHEDULE_MODULE'
};

export const Device = {
    DESKTOP: 'desktop',
    HANDSET: 'handset',
    TABLET: 'tablet'
};

export const BucketStatus = {
    WEB_LIVE: 'WEB_LIVE',
    WEB_UPCOMING: 'WEB_UPCOMING'
};

export const PageType = {
    HOME: 'HOME',
    COLLECTION: 'COLLECTION',
    FEATURES: 'FEATURES'
};

export const PlayerError = {
    AUTHORIZATION: 'AUTHORIZATION'
};

export const PlayerEvents = {
    ESPN_CONTENT_LOADED: 'espn.contentloaded',
    ESPN_PROGRAM_CHANGE: 'espn.programchange',
    ESPN_AUTOPLAY_TOGGLED: 'espn.autoplaytoggled'
};

export const Route = {
    HOME: '',
    FEATURES: 'features',
    SCHEDULE: 'schedule',
    PLAYER: 'player'
};

export const Storage = {
    Analytics: {
        IS_AUTHENTICATING: 'IS_AUTHENTICATING'
    }
};

export const ModalType = {
    POPUP: 'POPUP',
    FLASH: 'FLASH',
    BLACKOUT_MAP: 'BLACKOUT_MAP',
    IFRAME_AUTH: 'IFRAME_AUTH'
};

// list of URL query flags we use
export const Flags = {
    DEBUG_LOCALE: 'debug_locale', // used for overriding locale
    PLAYER_TECH: 'playertech', // overrides the player tech (for forcing brightcove in webviews).
    ROADBLOCK: 'roadblock', // set to false to disable the authenticated content roadblock,
    FROM_ROADBLOCK: 'rb', // set this to indicate that we were linked from the roadblock page (prevents cyclic redirection)
    HIDENAV: 'hidenav' // Used by webview in apps to remove top nav bars
};

export const PlayerPlacement = {
    HERO: 'hero',
    PLAYER: 'player'
};

export default {
    AddToCalendarPlacement,
    AdobePass,
    AlertPlacement,
    Api,
    AppEnvs,
    BucketLayout,
    BucketStatus,
    PageType,
    PlayerError,
    PlayerEvents,
    Route,
    Storage,
    ModalType,
    Flags
};



// WEBPACK FOOTER //
// ./app/enums.js